import { Controller } from "@hotwired/stimulus"

// Marks a builder section card. Its values carry the section and form ids the
// builder's sortable code reads; deleting a section is the ⋮ menu's own
// confirmation and route (TASK-267.6), so there's no delete action here.
export default class extends Controller {
  static values = {
    sectionId: String,
    formId: String
  }
}
